export const localConfig = {
    baseUrl: 'http://dev.sofology.local:3000',
    hybrisBaseUrl: 'https://sit.g.sofology.co.uk/swkcommercewebservices',
    hybrisProxyBaseUrl: 'https://salesorderprocessing.sit.sofology.co.uk',
    accountBaseUrl: 'https://myaccount.sit.sofology.co.uk',
    forgotPasswordBaseUrl: 'https://myaccount.sit.sofology.co.uk',
    donationBaseUrl: 'https://donations.sit.sofology.co.uk',
    fortAwesomeKitUrl: 'https://use.fortawesome.com/61a9ad22.js',
    custexBaseUrl: 'https://custex.sit.sofology.co.uk',
    logisticsUrl: 'https://logistics.sit.sofology.co.uk',
    reservationUrl: 'https://inventory.sit.sofology.co.uk/sql-reservations',
    paymentUrl: 'https://api.sit.sofology.co.uk/api/payments',
    ifcConfigUrl: 'https://api.sit.sofology.co.uk/api',
    webSiteBaseUrl: 'https://www.sit.sofology.co.uk',
    paypal: {
        env: 'sandbox',
        client: {
            sandbox: 'AbdzWd3vpYMFTnAKFbZtcFnsOiKrivYlFazcm6gL_rkpylkZGjK2UytYCf0EwwrgtGGT952L7XOLOL0l',
            production: 'AdWII6CQL0_7ALJl7KnyS4nBjFdpuo--PCmqJLgpdEaDzKkl26WeCZI52yD5flgKfsfkch1YDuYxMGxZ'
        }
    },
    adyen: {
        clientKey: 'test_IITAUQZOB5HVFGQY6SYJC3NGYI6DKSUS',
        environment: 'test',
        isAnalyticEnabled: true
    },
    gtmAffiliation: 'DEV',
    olapicKey: '06d3f7e5b01bed8f98b0e1222f500fd81387414fbf9433133f5f8ef89620455f',
    enableErrorLogging: false,
    logsBaseUrl: 'https://salesorderprocessing.sit.sofology.co.uk/api/log',
    rabbitBaseUrl: 'https://checkout.sit.sofology.co.uk/api/rabbit/Basket'
};